import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="6.8mm"
    height={23.814}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 53272 49360"
    {...props}
  >
    <path
      d="M48319 37951V2574h2377V0H2494v2574h2458v35377C2156 38333 0 40725 0 43626c0 3166 2568 5734 5735 5734 3166 0 5734-2568 5734-5734 0-2901-2157-5293-4953-5675V2574h12370v35377c-2795 382-4951 2774-4951 5675 0 3166 2568 5734 5734 5734 3167 0 5735-2568 5735-5734 0-2901-2156-5293-4953-5675V2574h12371v35377c-2797 382-4953 2774-4953 5675 0 3166 2567 5734 5735 5734 3166 0 5734-2568 5734-5734 0-2901-2157-5293-4953-5675V2574h12370v35377c-2796 382-4952 2774-4952 5675 0 3166 2568 5734 5734 5734 3167 0 5735-2568 5735-5734-1-2901-2157-5293-4953-5675z"
      style={{
        fill: "#221f1f",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
